import { LayoutStyles } from './LayoutStyles'
import React, { ReactNode, useState } from 'react'
import useMediaQueries from '../../hooks/useMediaQuery'
import { ContentComponent } from '../content/ContentComponent'
import { MenuComponent, MenuProperties } from '../menu/MenuComponent'
import { DrawerComponent, DrawerProperties } from '../drawer/DrawerComponent'

interface LayoutProperties {
    drawer: DrawerProperties
    header: MenuProperties
    children: ReactNode
}

export function LayoutComponent(properties: LayoutProperties) {
    const matches = useMediaQueries({
        isTabletOrMobile: '(max-width: 1220px)',
    })

    const [showDrawer, setShowDrawer] = useState(false)

    const handlerClickEventDrawer = (navegate: boolean) => {
        if (navegate) {
            setShowDrawer(false)
        }
    }

    return (
        <div style={LayoutStyles.container}>
            <DrawerComponent
                {...properties.drawer}
                open={showDrawer}
                onClose={() => setShowDrawer(false)}
                responsive={matches.isTabletOrMobile}
                onClickEvent={handlerClickEventDrawer}
            />
            <ContentComponent responsive={matches.isTabletOrMobile}>
                <MenuComponent
                    {...properties.header}
                    responsive={matches.isTabletOrMobile}
                    onMenu={() => setShowDrawer(!showDrawer)}
                />
                <div style={LayoutStyles.content}>
                    <div
                        style={{
                            ...LayoutStyles.spaces,
                            ...(matches.isTabletOrMobile && {
                                marginRight: 10,
                                marginLeft: 10,
                            }),
                        }}
                    >
                        {properties.children}
                    </div>
                </div>
            </ContentComponent>
            {matches.isTabletOrMobile && showDrawer && (
                <button
                    style={LayoutStyles.background}
                    onClick={() => setShowDrawer(!showDrawer)}
                />
            )}
        </div>
    )
}
